import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import PageBanner from 'LuxKit/Banners/PageBanner'

function CookiesDisabledWarning() {
  const intl = useIntl()
  const [areCookiesEnabled, setCookiesAreEnabled] = useState<boolean>(true)

  useEffect(() => {
    if (window.navigator.cookieEnabled) {
      setCookiesAreEnabled(true)
    } else {
      document.cookie = 'cookietest=1'
      setCookiesAreEnabled(document.cookie.includes('cookietest='))
      document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'
    }
  }, [])

  if (areCookiesEnabled) {
    return null
  }

  return <PageBanner kind="warning" align="center">
    {intl.formatMessage(
      {
        id: 'KQ3C4i6G-FhOhuNsW6m0',
        defaultMessage: 'Oops! Your browser seems to have cookies disabled. Make sure cookies are enabled or open a new window.',
        description: 'Warning message displayed when browser cookies are disabled',
      },
    )}
  </PageBanner>
}

export default CookiesDisabledWarning
